module.exports = __webpack_public_path__ + "media/images/users/purchases/purchase_benefit_3-b86de2093b3ff9431f9d520eaf61c8b5.png";